import styled from 'styled-components';
import theme from 'styles/theme';

export const FiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 30px;
  gap: 12px;
  flex-wrap: wrap;
  background-color: ${theme.colors.white};
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 14px 16px;
    gap: 10px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    padding: 12px;
    gap: 8px;
  }

  @media (max-width: 360px) {
    padding: 8px;
    gap: 6px;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    width: 100%;
    gap: 6px;
  }

  @media (max-width: 360px) {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }
`;

export const FilterLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${theme.colors.secondaryText};
  white-space: nowrap;

  @media (max-width: 360px) {
    font-size: 12px;
`;

export const Select = styled.select`
  height: 38px;
  padding: 0 10px;
  border: 0.5px solid ${theme.colors.borderColor};
  border-radius: 10px;
  font-size: 13px;
  color: ${theme.colors.primaryText};
  background-color: ${theme.colors.white};
  cursor: pointer;
  outline: none;

  &:focus {
    border-color: ${theme.colors.secondary};
  }

  @media (max-width: 480px) {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: 360px) {
    width: 100%;
    font-size: 12px;
    padding: 10px 10px;
  }
`;

export const Separator = styled.span`
  font-size: 14px;
  color: ${theme.colors.secondaryText};
  padding: 0 4px;

  @media (max-width: 480px) {
    display: none;
  }
`;

export const FilterContainerSubscribers = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${theme.colors.white};
  border-radius: 8px 8px 0 0;
  .inline_title {
    padding-top: 22px;
    padding-left: 30px;
    padding-bottom: 22px;

    @media (max-width: 768px) {
      padding-left: 16px;
    }

    @media (max-width: 480px) {
      padding: 14px 12px;
      font-size: 14px;
    }

    @media (max-width: 360px) {
      padding: 10px 8px;
      font-size: 13px;
    }
  }
`;
